<template>
  <div>
    <el-form
      ref="formData"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
    >
      <el-row :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
          <el-form-item label="节点名称" prop="linePointName">
            <el-input
              clearable
              v-model="formData.linePointName"
              placeholder="请输入节点名称"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
          <el-form-item label="节点距离" prop="distance">
            <el-input-number
              style="width:100%"
              clearable
              v-model="formData.distance"
              :step="10"
              :precision="0"
              :min="0"
              controls-position="right"
              placeholder="请选择节点距离"
            ></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :sm="{ span: 12 }" :md="{ span: 12 }" :lg="{ span: 12 }">
          <el-form-item label="节点地址" prop="linePointAddress">
            <el-col :span="20" style="padding:0px">
              <el-input
                v-model="formData.linePointAddress"
                placeholder="请填入节点地址"
              >
              </el-input>
            </el-col>
            <el-col :span="2">
              <el-tooltip
                content="点击查看地理位置，获取节点经纬度"
                placement="bottom-start"
              >
                <el-button
                  icon="el-icon-search"
                  circle
                  @click="openCoordPickerDialog()"
                ></el-button>
              </el-tooltip>
            </el-col>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 12 }" :md="{ span: 12 }" :lg="{ span: 12 }">
          <el-form-item label="节点经纬度">
            <el-input
              v-model="formData.positionText"
              placeholder="请点击左边按钮查看地理位置"
              disabled
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
          <el-form-item label="省/市/县">
            <region-cascader
              filterable
              :show="regionShow"
              :provinceCode.sync="formData.provinceCode"
              :provinceName.sync="formData.provinceName"
              :cityCode.sync="formData.cityCode"
              :cityName.sync="formData.cityName"
              :districtCode.sync="formData.districtCode"
              :districtName.sync="formData.districtName"
            />
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
          <el-form-item label="节点顺序" prop="sortOrder">
            <el-input-number
              style="width:100%"
              clearable
              v-model="formData.sortOrder"
              :step="1"
              :precision="0"
              :min="1"
              controls-position="right"
              placeholder="请选择节点顺序"
            ></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
          <el-form-item label="收发货方" prop="linePointType">
            <br />
            <el-radio label="R" v-model="formData.linePointType"
              >收货方</el-radio
            >
            <el-radio label="D" v-model="formData.linePointType"
              >发货方</el-radio
            >
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
          <el-form-item label="有效状态" prop="linePointStatus">
            <br />
            <el-radio label="Y" v-model="formData.linePointStatus"
              >有效</el-radio
            >
            <el-radio label="N" v-model="formData.linePointStatus"
              >无效</el-radio
            >
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!-- region 地图 dialog -->
    <el-dialog
      append-to-body
      v-if="openCoordPickerDialogOptions.visible"
      v-el-dialog-drag
      show-close
      visible
      width="900px"
      :title="openCoordPickerDialogOptions.title"
      :close-on-click-modal="false"
      :before-close="() => this.cancelCoordPickerDialog()"
    >
      <coord-picker
        style="height:450px"
        bottom="0px"
        :address="formData.linePointAddress"
        :location="formData.positionText"
        @change="coordChange"
        ref="coordPicker"
      />
      <span slot="footer">
        <el-button size="small" @click="cancelCoordPickerDialog()"
          >取消</el-button
        >
        <el-button
          type="primary"
          size="small"
          v-if="!openCoordPickerDialogOptions.disabled"
          @click="saveCoord()"
          >保存</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      append-to-body
      title="提示信息"
      :visible.sync="backDialogVisible"
      v-el-dialog-drag
      width="30%"
    >
      <span>是否要保存更改</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small"
          >取消</el-button
        >
        <el-button @click="close()" size="small">不保存</el-button>
        <el-button type="primary" size="small" @click="save()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import validate from '@/libs/util.validate'
export default {
  props: {
    disabled: Boolean,
    lineCode: String,
    linePointCode: String,
  },
  components: {},
  data() {
    return {
      regionShow: false,
      positionText: '',
      openCoordPickerDialogOptions: {
        visible: false,
      },
      backDialogVisible: false,
      formData: {
        positionText: '',
        custCode: 'uuid',
        linePointStatus: 'Y',
        lineCode: this.lineCode,
      },
      rules: {
        linePointName: [
          { required: true, message: '请输入节点名称', trigger: 'blur' },
        ],
        linePointAddress: [
          { required: true, message: '请输入详细地址', trigger: 'blur' },
        ],
        distance: [
          { required: true, message: '请选择节点距离', trigger: 'change' },
        ],
        linePointType: [
          { required: true, message: '请选择收发货方', trigger: 'change' },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    coordChange(val) {
      this.positionText = val
    },
    openCoordPickerDialog() {
      this.backDialogVisible = false
      this.openCoordPickerDialogOptions.visible = true
    },
    cancelCoordPickerDialog() {
      this.backDialogVisible = true
    },
    saveCoord() {
      this.formData.positionText = this.positionText
      this.backDialogVisible = false
      this.openCoordPickerDialogOptions.visible = false
    },
    closeCoord() {
      this.positionText = ''
      this.backDialogVisible = false
      this.openCoordPickerDialogOptions.visible = false
    },
    getData() {
      if (!this.linePointCode) return (this.regionShow = true)
      this.$api
        .contractLinePointDetailApi({
          linePointCode: this.linePointCode,
        })
        .then((res) => {
          this.formData = res.body
          this.regionShow = true
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.formData])
      if (!result) {
        this.backDialogVisible = false
        return
      }
      if (this.formData.positionText) {
        this.formData.linePointLongitude = this.formData.positionText.split(
          ','
        )[0]
        this.formData.linePointLatitude = this.formData.positionText.split(
          ','
        )[1]
      }
      let loadingInstance = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      this.$api
        .contractLinePointSaveApi(this.formData)
        .then((res) => {
          loadingInstance.close()
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
          this.close()
          this.$emit('reload')
        })
        .catch(() => {
          loadingInstance.close()
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
    handleChange(value) {
      console.log(value)
    },
  },
}
</script>
